// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".display-cover[data-v-9f5cd270]{width:320px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
